import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './team1.css'

const Team1 = (props) => {
  return (
    <div id="team" className={`team1-team1 thq-section-padding ${props.rootClassName} `}>
      <div className="team1-container1"></div>
      <div className="team1-container2 thq-section-max-width">
        <div className="team1-section-title">
          <div className="team1-content10">
            <h2>
              {props.heading1 ?? (
                <Fragment>
                  <h2 className="team1-text34 thq-heading-2">Meet Our Team</h2>
                </Fragment>
              )}
            </h2>
          </div>
        </div>
        <div className="team1-max-width thq-section-max-width">
          <div className="team1-content11">
            <div className="team1-content12">
              <div className="team1-row1">
                <div className="team1-card1">
                  <img
                    alt={props.member1Alt}
                    src={props.member1Src}
                    className="team1-placeholder-image1 thq-img-round thq-img-ratio-1-1"
                  />
                  <div className="team1-content13">
                    <div className="team1-title1">
                      <span>
                        {props.member1 ?? (
                          <Fragment>
                            <span className="team1-text41 thq-body-small">
                              Nuno Perdigão
                            </span>
                          </Fragment>
                        )}
                      </span>
                      <span>
                        {props.member1Job ?? (
                          <Fragment>
                            <span className="team1-text33 thq-body-small">
                              CEO &amp; Founder
                            </span>
                          </Fragment>
                        )}
                      </span>
                    </div>
                    <span>
                      {props.member2Content22 ?? (
                        <Fragment>
                          <span className="team1-text47 thq-body-small">
                            Leads business development with over 19 years
                            experience
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="team1-social-icons1">
                    <a href="https://www.linkedin.com/in/nunoperdigao/" target="_blank"> 
                      <svg
                        viewBox="0 0 877.7142857142857 1024"
                        className="thq-icon-small"
                      >
                        <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="team1-card2">
                  <img
                    alt={props.member2Alt}
                    src={props.member2Src}
                    className="team1-placeholder-image2 thq-img-round thq-img-ratio-1-1"
                  />
                  <div className="team1-content14">
                    <div className="team1-title2">
                      <span>
                        {props.member2 ?? (
                          <Fragment>
                            <span className="team1-text32 thq-body-small">
                              Ricardo Jorge
                            </span>
                          </Fragment>
                        )}
                      </span>
                      <span>
                        {props.member2Job ?? (
                          <Fragment>
                            <span className="team1-text40 thq-body-small">
                              Director &amp; Founder
                            </span>
                          </Fragment>
                        )}
                      </span>
                    </div>
                    <span>
                      {props.member2Content23 ?? (
                        <Fragment>
                          <span className="team1-text43 thq-body-small">
                            20 years in IT, specialized in project management
                            and solutions design for banking and insurance.
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="team1-social-icons2">
                    <a href="https://www.linkedin.com/in/ricardojjorge/" target="_blank">   
                      <svg
                        viewBox="0 0 877.7142857142857 1024"
                        className="thq-icon-small"
                      >
                        <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="team1-card3">
                  <img
                    alt={props.member3Alt}
                    src={props.member3Src}
                    className="team1-placeholder-image3 thq-img-round thq-img-ratio-1-1"
                  />
                  <div className="team1-content15">
                    <div className="team1-title3">
                      <span>
                        {props.member3 ?? (
                          <Fragment>
                            <span className="team1-text35 thq-body-small">
                              Pedro Nuno Silva
                            </span>
                          </Fragment>
                        )}
                      </span>
                      <span>
                        {props.member3Job ?? (
                          <Fragment>
                            <span className="team1-text31 thq-body-small">
                              Director &amp; Founder
                            </span>
                          </Fragment>
                        )}
                      </span>
                    </div>
                    <span>
                      {props.member2Content24 ?? (
                        <Fragment>
                          <span className="team1-text42 thq-body-small">
                            Expert in project management and solution
                            architecture and automation with 12+ years
                            experience
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="team1-social-icons3">
                  <a href="https://www.linkedin.com/in/pnrsilva/" target="_blank">                  
                    <svg
                      viewBox="0 0 877.7142857142857 1024"
                      className="thq-icon-small"
                    >
                      <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                    </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div className="team1-row2">
                <div className="team1-card1">
                  <img
                    alt={props.member1Alt2}
                    src={props.member1Src2}
                    className="team1-placeholder-image4 thq-img-round thq-img-ratio-1-1"
                  />
                  <div className="team1-content16">
                    <div className="team1-title4">
                      <span>
                        {props.member12 ?? (
                          <Fragment>
                            <span className="team1-text30 thq-body-small">
                              João Verdilheiro
                            </span>
                          </Fragment>
                        )}
                      </span>
                      <span>
                        {props.member1Job2}
                      </span>
                    </div>
                    <span>
                      {props.member2Content21}
                    </span>
                  </div>
                  <div className="team1-social-icons4">
                    <a href="https://www.linkedin.com/in/joaoverdilheiro1997/" target="_blank"> 
                      <svg
                        viewBox="0 0 877.7142857142857 1024"
                        className="thq-icon-small"
                      >
                        <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="team1-card2">
                  <img
                    alt={props.member2Alt2}
                    src={props.member2Src2}
                    className="team1-placeholder-image5 thq-img-round thq-img-ratio-1-1"
                  />
                  <div className="team1-content17">
                    <div className="team1-title5">
                      <span>
                        {props.member22 ?? (
                          <Fragment>Bruno Anastacio</Fragment>
                        )}
                      </span>
                      <span>
                        {props.member2Job2}
                      </span>
                    </div>
                    <span>
                      {props.member2Content2}
                    </span>
                  </div>
                  <div className="team1-social-icons5">
                    <a href="https://www.linkedin.com/in/bruno-anastacio/" target="_blank"> 
                      <svg
                        viewBox="0 0 877.7142857142857 1024"
                        className="thq-icon-small"
                      >
                        <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="team1-card3">
                  <img
                    alt={props.member3Alt2}
                    src={props.member3Src2}
                    className="team1-placeholder-image5 thq-img-round thq-img-ratio-1-1"
                  />
                  <div className="team1-content17">
                    <div className="team1-title5">
                      <span>
                        {props.member32 ?? (
                          <Fragment>Flavio</Fragment>
                        )}
                      </span>
                      <span>
                        {props.member3Job2}
                      </span>
                    </div>
                    <span>
                      {props.member3Content2}
                    </span>
                  </div>
                  <div className="team1-social-icons5">
                    <a href="https://www.linkedin.com/in/flaviogil85/" target="_blank"> 
                      <svg
                        viewBox="0 0 877.7142857142857 1024"
                        className="thq-icon-small"
                      >
                        <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>

              <div className="team1-row2">
                <div className="team1-card1">
                  <img
                    alt={props.member1Alt3}
                    src={props.member1Src3}
                    className="team1-placeholder-image4 thq-img-round thq-img-ratio-1-1"
                  />
                  <div className="team1-content16">
                    <div className="team1-title4">
                      <span>
                        {props.member13 ?? (
                          <Fragment>António Eusébio</Fragment>
                        )}
                      </span>
                      <span>
                        {props.member1Job3}
                      </span>
                    </div>
                  </div>
                  <div className="team1-social-icons4">
                    <a href="https://www.linkedin.com/in/ant%C3%B3nioeus%C3%A9bio/" target="_blank"> 
                      <svg
                        viewBox="0 0 877.7142857142857 1024"
                        className="thq-icon-small"
                      >
                        <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="team1-card2">
                  <img
                    alt={props.member2Alt3}
                    src={props.member2Src3}
                    className="team1-placeholder-image5 thq-img-round thq-img-ratio-1-1"
                  />
                  <div className="team1-content17">
                    <div className="team1-title5">
                      <span>
                        {props.member23 ?? (
                          <Fragment>Bernardo</Fragment>
                        )}
                      </span>
                      <span>
                        {props.member2Job3}
                      </span>
                    </div>
                  </div>
                  <div className="team1-social-icons5">
                    <a href="https://www.linkedin.com/in/rui-bernardo-rodrigues/" target="_blank"> 
                      <svg
                        viewBox="0 0 877.7142857142857 1024"
                        className="thq-icon-small"
                      >
                        <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="team1-card3">
                  <img
                    alt={props.member3Alt3}
                    src={props.member3Src3}
                    className="team1-placeholder-image5 thq-img-round thq-img-ratio-1-1"
                  />
                  <div className="team1-content17">
                    <div className="team1-title5">
                      <span>
                        {props.member33 ?? (
                          <Fragment>Rita</Fragment>
                        )}
                      </span>
                      <span>
                        {props.member3Job3}
                      </span>
                    </div>
                  </div>
                  <div className="team1-social-icons5">
                    <a href="https://www.linkedin.com/in/rita-isabel-andrino-seco-martins-80a589144/" target="_blank"> 
                      <svg
                        viewBox="0 0 877.7142857142857 1024"
                        className="thq-icon-small"
                      >
                        <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="team1-content18">
              <div className="team1-content19">
                <h2>
                  {props.heading2 ?? (
                    <Fragment>
                      <h2 className="team1-text45 thq-heading-2">
                        We’re hiring!
                      </h2>
                    </Fragment>
                  )}
                </h2>
                <span>
                  {props.content3 ?? (
                    <Fragment>
                      <span className="team1-text37 thq-body-small">
                        <span>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit.
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                        <span>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
              <button className="team1-button thq-button-filled">
                <span>
                  {props.actionContent ?? (
                    <Fragment>
                      <span className="team1-text44 thq-body-small">
                        Open positions
                      </span>
                    </Fragment>
                  )}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Team1.defaultProps = {
  member1Job2: undefined,
  member12: undefined,
  member3Job: undefined,
  member1Alt: undefined,
  member2: undefined,
  member1Job: undefined,
  heading1: undefined,
  member3: undefined,
  member2Job2: undefined,
  rootClassName: '',
  content3: undefined,
  member2Job: undefined,
  member2Alt2: undefined,
  member1: undefined,
  member2Content24: undefined,
  member2Content23: undefined,
  member1Src:
    '/images/people/NunoPerdigao.jpg',
  member2Alt: undefined,
  member2Src:
    '/images/people/RicardoJorge.jpg',
  actionContent: undefined,
  member3Alt: undefined,
  heading2: undefined,
  member3Src:
    '/images/people/PedroNSilva.jpg',

  member1Src2:
    '/images/people/JoaoVerdilheiro.jpg',
  member1Alt2: undefined,  
  member22: undefined,
  member2Src2:
    '/images/people/BrunoAnastacio.jpg',
  member2Content2: undefined,
  member2Content21: undefined,
  member2Content22: undefined,

  member3Src2: 
    '/images/people/FlavioGil.jpg',

    member1Src3:
    '/images/people/AntonioEusebio.jpg',
    member2Src3:
    '/images/people/RuiBernardoRodrigues.jpg',
    member3Src3:
    '/images/people/RitaAndrino.jpg',
}

Team1.propTypes = {
  member1Job2: PropTypes.element,
  member12: PropTypes.element,
  member3Job: PropTypes.element,
  member1Alt: PropTypes.string,
  member2: PropTypes.element,
  member1Job: PropTypes.element,
  heading1: PropTypes.element,
  member3: PropTypes.element,
  member2Job2: PropTypes.element,
  rootClassName: PropTypes.string,
  content3: PropTypes.element,
  member2Job: PropTypes.element,
  member2Alt2: PropTypes.string,
  member1: PropTypes.element,
  member2Content24: PropTypes.element,
  member2Content23: PropTypes.element,
  member1Src: PropTypes.string,
  member2Alt: PropTypes.string,
  member2Src: PropTypes.string,
  actionContent: PropTypes.element,
  member3Alt: PropTypes.string,
  heading2: PropTypes.element,
  member3Src: PropTypes.string,
  member2Src2: PropTypes.string,
  member2Content2: PropTypes.element,
  member2Content22: PropTypes.element,
  member1Src2: PropTypes.string,
  member22: PropTypes.element,
  member2Content21: PropTypes.element,
  member1Alt2: PropTypes.string,
}

export default Team1
